import { ConfigurablePropsFromDescription } from '../../../helpers/widget'
import { Override } from '../../../utils/typescript'
import { WidgetColors } from '../../styling/widget-colors'

export type FilterppConfigProps = Override<
  ConfigurablePropsFromDescription<typeof filterppOptions>,
  {customButtonStyling: WidgetColors}
>

export const filterppOptions = [
  {
    name: 'stateId',
    type: 'text',
    label: 'unique state-id (REQUIRED WHEN USING MULTIPLE INSTANCES TO RECOVER FILTER STATE FOR EXAMPLE IN POP UP)'
  },
  {
    name: 'snippetSubject',
    type: 'text',
    label: 'subject (without question-mark) for filterSnippet statements'
  },
  {
    name: 'snippetTopic',
    type: 'text',
    label: 'Topic to publish filterSnippet to'
  },
  {
    name: 'emptyStringOnNoFilter',
    type: 'boolean',
    label: 'Publish an empty string when no filter',
  },
  {
    name: 'closePopupOnApply',
    type: 'boolean',
    label: 'Close popup upon pressing apply',
  },
  {
    name: "custom",
    type: 'filterpp-custom',
    label: 'Custom configuration',
  },
  {
    name: 'customButtonStyling',
    type: 'json-text',
    label: 'Custom button-styling configuration (CSS-variables)'
  },
] as const
